import { render, staticRenderFns } from "./SettingsFacilities.vue?vue&type=template&id=d60fc6b6&scoped=true"
import script from "./SettingsFacilities.vue?vue&type=script&lang=js"
export * from "./SettingsFacilities.vue?vue&type=script&lang=js"
import style0 from "./SettingsFacilities.vue?vue&type=style&index=0&id=d60fc6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60fc6b6",
  null
  
)

export default component.exports